import { reactive } from 'vue';
import { calculateTax as runCalculation } from './taxCalculator.js';

const state = reactive({
  scenarios: [],
  currentResult: null,
  isCalculating: false,
});

function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 9);
}

function getScenarios() {
  return state.scenarios.slice();
}

function getScenarioById(id) {
  return state.scenarios.find((s) => s.id === id) || null;
}

function createScenario(scenario) {
  const now = new Date().toISOString();
  const newScenario = {
    id: generateId(),
    name: scenario.name || 'Untitled',
    formType: scenario.formType || '90',
    input: { ...scenario.input },
    result: scenario.result || null,
    createdAt: now,
    updatedAt: now,
  };
  state.scenarios.push(newScenario);
  return newScenario;
}

function updateScenario(id, updates) {
  const idx = state.scenarios.findIndex((s) => s.id === id);
  if (idx === -1) return null;
  const scenario = state.scenarios[idx];
  Object.assign(scenario, updates, { updatedAt: new Date().toISOString() });
  return scenario;
}

function deleteScenario(id) {
  const idx = state.scenarios.findIndex((s) => s.id === id);
  if (idx === -1) return false;
  state.scenarios.splice(idx, 1);
  return true;
}

function calculateTax(input) {
  state.isCalculating = true;
  try {
    const result = runCalculation(input);
    state.currentResult = result;
    return result;
  } finally {
    state.isCalculating = false;
  }
}

function clearResult() {
  state.currentResult = null;
}

export {
  state,
  getScenarios,
  getScenarioById,
  createScenario,
  updateScenario,
  deleteScenario,
  calculateTax,
  clearResult,
};
